import { apiUrl } from '../constants/global';
import { getLoggedUser } from '../state/user';
// import axios from 'axios';
const user = getLoggedUser();

async function getAllSectors() {
  let endpoint = `${apiUrl}sector/list`;
  return fetch(endpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

export { getAllSectors };
